/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Bold_Elk_ScanInputs */

const en_warm_bold_elk_scan = /** @type {(inputs: Warm_Bold_Elk_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search segments...`)
};

const de_warm_bold_elk_scan = /** @type {(inputs: Warm_Bold_Elk_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmente suchen...`)
};

/**
* | output |
* | --- |
* | "Search segments..." |
*
* @param {Warm_Bold_Elk_ScanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_bold_elk_scan = /** @type {((inputs?: Warm_Bold_Elk_ScanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Bold_Elk_ScanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_bold_elk_scan(inputs)
	return de_warm_bold_elk_scan(inputs)
});